import React from 'react';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import Link from 'next/link';
import { logEvent } from 'utils/eventTracking';
import { PageNumber, LabelContainer, Label } from './style';

const handleClick =
  (previousPageNumber: number, currentPageNumber: number) => () => {
    logEvent('SEARCH_RESULTS_PAGE_NUMBER_CLICKED', {
      currentPageNumber,
      previousPageNumber
    });
  };

const PagingLink =
  (pathName: string, term: string, previousPageNumber: number) =>
  (pageNumber: number, isActive: boolean, label?: string): JSX.Element => {
    if (label) {
      const isNext = label === 'Next';
      return (
        <Link href={{ pathname: pathName, query: { page: pageNumber, term } }}>
          <LabelContainer label={label}>
            {!isNext && <FaArrowLeft height={16} width={16} />}
            <Label
              size="body1_new"
              fontWeight="semiBold"
              color="primaryLink"
              label={label}
            >
              <a onClick={handleClick(previousPageNumber, pageNumber)}>
                {label}
              </a>
            </Label>
            {isNext && <FaArrowRight height={16} width={16} />}
          </LabelContainer>
        </Link>
      );
    } else {
      return (
        <Link href={{ pathname: pathName, query: { page: pageNumber, term } }}>
          <PageNumber
            textAs="a"
            size="body1_new"
            color={isActive ? 'secondaryBrand' : 'primaryLink'}
            fontWeight="semiBold"
            isActive={isActive}
          >
            <a onClick={handleClick(previousPageNumber, pageNumber)}>
              {pageNumber}
            </a>
          </PageNumber>
        </Link>
      );
    }
  };
export default PagingLink;
